/*
 * File: d:\projects\AutoFiFront\src\Content\SVG\ValuesSVG\Passion.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Tuesday April 18th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday April 18th 2023 9:33:45 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { SVGProps } from 'Content/SVG/SVGProps';

function Passion(props: SVGProps) {
    return(
        <svg id="Calque_1" fill={props.fill} width={props.width} stroke={props.stroke} strokeWidth={props.strokeWidth} data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080">
            <path d="M22,403.59c3.42-20.21,5.33-40.81,10.51-60.55,27.29-104.04,88.14-180.07,192.36-212.96,111.2-35.1,208.22-6.8,288.48,77.86,9.46,9.98,17.87,20.95,27.27,32.06,9.06-10.72,17.52-21.54,26.82-31.58,44.23-47.75,97.17-80.86,162.5-89.2,100.97-12.89,187.25,17.93,253.65,95.63,66.4,77.7,85.76,169.48,70.5,269.1-9.67,63.13-38.62,118.19-76.36,168.82-49.53,66.46-109.84,122.59-172.06,176.72-73.35,63.81-147.09,127.17-220.79,190.58-28.33,24.38-58.76,25.52-85.98,1.92-96.14-83.37-192.52-166.5-287.49-251.19-48.18-42.96-91.44-90.89-126.83-145.36-33.41-51.42-55.76-106.81-61.07-168.41-.2-2.3-.98-4.55-1.5-6.83,0-15.53,0-31.06,0-46.59ZM540.3,977.65c2.65-2.08,4.8-3.63,6.8-5.36,81.97-70.85,164.44-141.14,245.7-212.8,56.77-50.06,110.75-103.06,152.83-166.74,40.05-60.6,59.82-126.54,50.64-199.53-9.91-78.77-43.64-144.18-113.62-185.32-65.21-38.34-134-43.05-203.25-9.82-40.94,19.65-71.18,51.7-96.45,88.76-3.61,5.29-6.86,10.85-10.63,16.02-16.69,22.83-46.43,22.73-63.39,.14-14.76-19.66-28.28-40.55-45.1-58.31-54.31-57.36-121.37-79.62-198.72-62.89-83.42,18.04-138.21,70.89-165.96,150.42-32.26,92.44-16.88,179.38,36.39,260.44,33.04,50.29,73.5,94.34,117.96,134.34,73.51,66.14,148.49,130.63,222.94,195.72,21.04,18.39,42.37,36.45,63.85,54.9Z"/>
        </svg>
    );
}

export default Passion;
